import { TableRowDto } from '@asset-metrix/portal-gateway-client-js';
import { useMutation } from '@tanstack/react-query';

import { updateTableRow } from '../api/portalGateway/updateTableRow';

type UseUpdateTableRowParams = {
  mutationSuccessHandler: () => void;
  mutationErrorHandler: () => void;
};

export function useUpdateTableRow({
  mutationSuccessHandler,
  mutationErrorHandler,
}: UseUpdateTableRowParams) {
  const { mutate, error, reset, status } = useMutation({
    mutationFn: updateTableRow,
    onSuccess: mutationSuccessHandler,
    onError: mutationErrorHandler,
  });

  return {
    error,
    status,
    reset,
    updateRow: (contentId: string, rowId: string, data: TableRowDto) => {
      return mutate({ contentId, rowId, data });
    },
  };
}
